import update from 'immutability-helper';
import { cloneDeep } from 'lodash';
import {
  FETCH_DISCOUNTS_START,
  FETCH_DISCOUNTS_SUCCESS,
  FETCH_DISCOUNTS_FAIL,
  WRITE_DISCOUNT_START,
  WRITE_DISCOUNT_SUCCESS,
  WRITE_DISCOUNT_FAIL,
  CHANGE_DISCOUNT_START,
  CHANGE_DISCOUNT_SUCCESS,
  CHANGE_DISCOUNT_FAIL,
  DELETE_DISCOUNT_START,
  DELETE_DISCOUNT_SUCCESS,
  DELETE_DISCOUNT_FAIL,
  UPDATE_DISCOUNTS_SUCCESS,
  WRITE_DISCOUNTS_SUCCESS,
  FETCH_DISCOUNT_SUCCESS,
  UPDATE_DISCOUNT_POSITION_SUCCESS,
  UPDATE_DISCOUNT_FIELD_POSITION_SUCCESS,
  UPDATE_DISCOUNTS_LIST,
  TOGGLE_ENTITY_SELECTION,
  TOGGLE_CATALOG_OPEN,
  REMOVE_CONDITION,
  SET_INITIAL_DATA,
  CLEAR_ALL_SELECTIONS,
  FETCH_COUPONS_START,
  FETCH_COUPONS_SUCCESS,
  FETCH_COUPONS_FAIL,
  CREATE_COUPON_START,
  CREATE_COUPON_SUCCESS,
  CREATE_COUPON_FAIL,
  GENERATE_COUPONS_START,
  GENERATE_COUPONS_SUCCESS,
  GENERATE_COUPONS_FAIL,
  DELETE_COUPON_START,
  DELETE_COUPON_SUCCESS,
  DELETE_COUPON_FAIL,
  DELETE_COUPONS_START,
  DELETE_COUPONS_SUCCESS,
  DELETE_COUPONS_FAIL,
  FETCH_DISCOUNT_SETTINGS_START,
  FETCH_DISCOUNT_SETTINGS_SUCCESS,
  FETCH_DISCOUNT_SETTINGS_FAIL,
  UPDATE_DISCOUNT_SETTINGS_START,
  UPDATE_DISCOUNT_SETTINGS_SUCCESS,
  UPDATE_DISCOUNT_SETTINGS_FAIL,
} from './action';

const initialState = {
  discounts: {
    items: [],
    total: 0,
  },
  discount: null,
  isLoading: true,
  isInitial: false,
  entities: {},
  catalogs: {},
  coupons: {
    items: [],
    total: 0,
    isLoading: false,
  },
  settings: null,
  isSettingsLoading: false,
  err: null,
};

let modifiedData;

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case FETCH_DISCOUNTS_START:
  case WRITE_DISCOUNT_START:
  case CHANGE_DISCOUNT_START:
  case DELETE_DISCOUNT_START:
    return {
      ...state,
      isLoading: true,
    };
  case FETCH_DISCOUNTS_SUCCESS:
    return {
      ...state,
      discounts: {
        items: payload?.items || [],
        total: payload?.total || 0,
      },
      isLoading: false,
      isInitial: true,
    };
  case FETCH_DISCOUNT_SUCCESS:
    return {
      ...state,
      discount: payload,
      isLoading: false,
      isInitial: true,
    };
  case WRITE_DISCOUNT_SUCCESS:
    if (state.discounts.items[state.discounts.items.length - 1]?.id === payload.id) {
      return { ...state };
    }
    return {
      ...state,
      discounts: {
        items: [...state.discounts.items, payload],
        total: state.discounts.total + 1,
      },
      isLoading: false
    };
  case CHANGE_DISCOUNT_SUCCESS:
    return {
      ...state,
      discounts: {
        items: state.discounts.items.map((item) => (item.id === payload.id ? { ...payload } : item)),
        total: state.discounts.total,
      },
      discount: { ...payload },
      isLoading: false
    };
  case UPDATE_DISCOUNTS_LIST:
    return {
      ...state,
      discounts: {
        items: state.discounts.items.map((item) => (+item.id === +payload.id ? { ...payload } : item)),
        total: state.discounts.total,
      },
    };
  case DELETE_DISCOUNT_SUCCESS:
    return {
      ...state,
      discounts: {
        items: state.discounts.items.filter((item) => item.id !== payload),
        total: state.discounts.total - 1,
      },
      isLoading: false
    };
  case UPDATE_DISCOUNTS_SUCCESS:
    modifiedData = update(state.discounts.items, {
      $splice: [
        [payload.dragIndex, 1],
        [payload.hoverIndex, 0, payload.dragCard],
      ],
    });
    return {
      ...state,
      discounts: {
        items: modifiedData,
        total: state.discounts.total,
      },
    };
  case WRITE_DISCOUNTS_SUCCESS:
    return {
      ...state,
      discounts: {
        ...state.discounts,
        items: payload,
      },
    };
  case FETCH_DISCOUNTS_FAIL:
  case WRITE_DISCOUNT_FAIL:
  case CHANGE_DISCOUNT_FAIL:
  case DELETE_DISCOUNT_FAIL:
    return {
      ...state,
      isLoading: false,
      err: payload,
    };
  case UPDATE_DISCOUNT_POSITION_SUCCESS:
    modifiedData = state.discounts.items.map((item) => {
      if (payload[item.id]) {
        const clonedItem = cloneDeep(item);
        clonedItem.position = payload[item.id];
        return clonedItem;
      }

      return item;
    });
    modifiedData.sort((a, b) => a.position - b.position);
    return {
      ...state,
      discounts: {
        items: modifiedData,
        total: state.discounts.total,
      },
      isLoading: false
    };
  case UPDATE_DISCOUNT_FIELD_POSITION_SUCCESS:
    const currentDiscount = state.discounts.items.find((item) => item.id === payload.parentId);
    const clonedDiscount = cloneDeep(currentDiscount);
    modifiedData = currentDiscount.fields.map((item) => {
      if (payload.positions[item.id]) {
        item.position = payload.positions[item.id];
      }

      return item;
    });
    modifiedData.sort((a, b) => a.position - b.position);
    clonedDiscount.fields = modifiedData;

    const updatedDiscounts = state.discounts.items.map((item) => {
      return item.id === payload.parentId ? clonedDiscount : item;
    });

    return {
      ...state,
      discounts: {
        items: updatedDiscounts,
        total: state.discounts.total,
      },
      discount: clonedDiscount,
      isLoading: false
    };

  case TOGGLE_ENTITY_SELECTION: {
    const { conditionId, entityId, isNestedValue } = payload;
    const entitiesI = state.entities[conditionId] || [];
    const selectedItem = entitiesI.find((item) => item.id === entityId);

    let updatedEntities;
    if (!isNestedValue) {
      // Добавляем или удаляем элемент (логика как в FormsModuleEntityData)
      updatedEntities = !selectedItem?.id
        ? [...entitiesI, { id: entityId, isNested: false }]
        : entitiesI.filter((item) => item.id !== entityId);
    } else {
      // Переключаем флаг isNested
      updatedEntities = entitiesI.map((item) => (
        item.id === entityId ? { id: entityId, isNested: !item.isNested } : item
      ));
    }

    return {
      ...state,
      entities: {
        ...state.entities,
        [conditionId]: updatedEntities,
      },
    };
  }

  case TOGGLE_CATALOG_OPEN: {
    const { conditionId, catalogId } = payload;
    const catalogsI = state.catalogs[conditionId] || [];
    let upd;

    if (catalogsI.includes(catalogId)) {
      upd = catalogsI.filter((id) => id !== catalogId);
    } else {
      upd = [...catalogsI, catalogId];
    }

    return {
      ...state,
      catalogs: {
        ...state.catalogs,
        [conditionId]: upd,
      },
    };
  }

  case REMOVE_CONDITION: {
    const { [payload]: _, ...restEntities } = state.entities;
    const { [payload]: __, ...restCatalogs } = state.catalogs;

    return {
      ...state,
      entities: restEntities,
      catalogs: restCatalogs,
    };
  }

  case SET_INITIAL_DATA: {
    const { conditionId, entities } = payload;
    return {
      ...state,
      entities: {
        ...state.entities,
        [conditionId]: entities,
      },
    };
  }

  case CLEAR_ALL_SELECTIONS:
    return {
      ...state,
      entities: {},
      catalogs: {},
    };

  case FETCH_COUPONS_START:
  case CREATE_COUPON_START:
  case GENERATE_COUPONS_START:
  case DELETE_COUPON_START:
  case DELETE_COUPONS_START:
    return {
      ...state,
      coupons: {
        ...state.coupons,
        isLoading: true,
      },
    };

  case FETCH_COUPONS_SUCCESS:
    return {
      ...state,
      coupons: {
        items: payload?.append
          ? [...state.coupons.items, ...(payload?.items || [])]
          : (payload?.items || []),
        total: payload?.total || 0,
        isLoading: false,
      },
    };

  case CREATE_COUPON_SUCCESS:
    return {
      ...state,
      coupons: {
        ...state.coupons,
        items: [...state.coupons.items, payload],
        total: state.coupons.total + 1,
        isLoading: false,
      },
    };

  case GENERATE_COUPONS_SUCCESS:
    return {
      ...state,
      coupons: {
        ...state.coupons,
        isLoading: false,
      },
    };

  case DELETE_COUPON_SUCCESS:
    return {
      ...state,
      coupons: {
        ...state.coupons,
        items: state.coupons.items.filter((item) => item.id !== payload),
        total: state.coupons.total - 1,
        isLoading: false,
      },
    };

  case DELETE_COUPONS_SUCCESS:
    return {
      ...state,
      coupons: {
        ...state.coupons,
        items: state.coupons.items.filter((item) => !payload.includes(item.id)),
        total: state.coupons.total - payload.length,
        isLoading: false,
      },
    };

  case FETCH_COUPONS_FAIL:
  case CREATE_COUPON_FAIL:
  case GENERATE_COUPONS_FAIL:
  case DELETE_COUPON_FAIL:
  case DELETE_COUPONS_FAIL:
    return {
      ...state,
      coupons: {
        ...state.coupons,
        isLoading: false,
      },
    };

  case FETCH_DISCOUNT_SETTINGS_START:
  case UPDATE_DISCOUNT_SETTINGS_START:
    return {
      ...state,
      isSettingsLoading: true,
    };

  case FETCH_DISCOUNT_SETTINGS_SUCCESS:
  case UPDATE_DISCOUNT_SETTINGS_SUCCESS:
    return {
      ...state,
      settings: payload,
      isSettingsLoading: false,
    };

  case FETCH_DISCOUNT_SETTINGS_FAIL:
  case UPDATE_DISCOUNT_SETTINGS_FAIL:
    return {
      ...state,
      isSettingsLoading: false,
    };

  default:
    return { ...state };
  }
};
